// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2fix8","errorLogs":"EditorFooter_errorLogs__TJqV9"};